module.exports = __webpack_public_path__ + "static/img/banner.2b43616.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202203/banner.png
// module id = OWkE
// module chunks = 0